import { SettingType_Enum } from '@weave/schema-gen-ts/dist/schemas/messaging/settings/v1/settings.pb';
import { MergedSettings } from '../types';

export const convertSettingTypeToKey = (settingType: SettingType_Enum): keyof MergedSettings | undefined => {
  switch (settingType) {
    case SettingType_Enum.AUTO_MESSAGING_LOCATION_SETTING:
      return 'autoMessagingLocationSetting';
    case SettingType_Enum.INBOX_LOCATION_SETTING:
      return 'inboxLocationSetting';
    case SettingType_Enum.INBOX_LOCATION_USER_SETTING:
      return 'inboxLocationUserSetting';
    case SettingType_Enum.INBOX_USER_SETTING:
      return 'inboxUserSetting';
    case SettingType_Enum.TEST_SETTING:
      return 'testSetting';
    case SettingType_Enum.TEST_NO_DEFAULT_SETTING:
      return 'testNoDefaultSetting';
    case SettingType_Enum.REPUTATION_USER_SETTING:
      return 'reputationUserSetting';
    case SettingType_Enum.REPUTATION_NOTIFICATIONS_LOCATION_USER_SETTING:
      return 'reputationNotificationsLocationUserSetting';
    case SettingType_Enum.WEAVE_ASSISTANT_LOCATION_SETTING:
      return 'weaveAssistantLocationSetting';
    case SettingType_Enum.AI_RECEPTIONIST_LOCATION_USER_SETTINGS:
      return 'aiReceptionistLocationUserSettings';
    case SettingType_Enum.BRAND_SETTING:
      return 'brandSetting';
    default:
      return undefined;
  }
};
